import React from 'react';

export interface SelectProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  size?: 'sm';
  className?: string;
  children?: React.ReactNode;
}

export function Select({
  size,
  className = '',
  children,
  ...rest
}: SelectProps) {
  return (
    <select
      className={['select', size === 'sm' ? 'select-sm' : '', className].join(
        ' '
      )}
      {...rest}
    >
      {children}
    </select>
  );
}

export default Select;
